export const defaultBaseUrl = 'https://api.boatpark.app/v2.10';